import React, { useEffect, useState } from "react"
import "react-quill/dist/quill.snow.css"


import { Card, CardBody, Col, Row } from "reactstrap"
import API_SERVICE from "shared/services/api-services"
import { notification } from "shared/utility/Utility"
import EditEmailContent from "./EditEmailContent"
let questionNo = 0

const EmailContent = () => {
  const [emailContent, setEmailContent] = useState("")
  const [edit, setEdit] = useState(false)

  const getEmailContent = async () => {
    try {
      const {
        data: { data },
      } = await API_SERVICE.fetchEmailContent()
      console.log(data)
      setEmailContent(data)
    } catch (error) {
      notification("error", API_SERVICE.handleErrors(error))
    }
  }

  const handleEdit = () => setEdit(true)

  useEffect(() => {
    getEmailContent()
  }, [edit])

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col xs={12}>
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-18">CMS-Email</h4>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs="12">
              <Card>
                {edit ? (
                  <EditEmailContent
                    setEdit={setEdit}
                    emailContent={emailContent[0] || {
                      subjectText: "",
                      bodyText: "",
                      ccEmails: [],
                    }}
                  />
                ) : (
                  <CardBody
                    style={{
                      minHeight: "calc(100vh - 230px)",
                    }}
                    className="email-content-container"
                  >
                    <div className="heading-container d-flex align-items-center justify-content-between">
                      <h1 className="heading">
                        {emailContent[0]?.subjectText}
                      </h1>
                      <div
                        className="edit-icon d-flex gap-1 align-items-center"
                        onClick={handleEdit}
                      >
                        <i className="bx bx-pencil"></i>
                        <span>Edit</span>
                      </div>
                    </div>
                    <p className="cc">
                      CC:{" "}
                      {emailContent[0]?.ccEmails.length === 0
                        ? "N/A"
                        : emailContent[0]?.ccEmails.map((email, index) => {
                            return (
                              <span key={index}>
                                {email}
                                {index + 1 === emailContent[0]?.ccEmails.length
                                  ? ""
                                  : ", "}
                              </span>
                            )
                          })}
                    </p>
                    <div
                      className="d-flex flex-column email-content"
                      dangerouslySetInnerHTML={{
                        __html: emailContent[0]?.bodyText,
                      }}
                    />
                  </CardBody>
                )}
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </>
  )
}

export default EmailContent
